/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateUserUsageLimit200ResponseReissueOneOf
 */
export interface UpdateUserUsageLimit200ResponseReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200ResponseReissueOneOf
     */
    'cardType': UpdateUserUsageLimit200ResponseReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof UpdateUserUsageLimit200ResponseReissueOneOf
     */
    'expiredDate': string;
}

export const UpdateUserUsageLimit200ResponseReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type UpdateUserUsageLimit200ResponseReissueOneOfCardTypeEnum = typeof UpdateUserUsageLimit200ResponseReissueOneOfCardTypeEnum[keyof typeof UpdateUserUsageLimit200ResponseReissueOneOfCardTypeEnum];


